import type { ScreenModule } from "../../../app/screen-module";
import { InvitesPage } from "../pages";

export default {
	id: "tenant-admin.invites",
	path: "/admin/invites",
	area: "tenant-admin",
	navGroup: "組織",
	label: "招待",
	roles: ["tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: InvitesPage,
} satisfies ScreenModule;
